import utils from "../common/util";

/**
 * Initialise the create game form
 * @param element
 */
const cmpCreateGameForm = {
    component: null,

    init: function (element)
    {
        utils.log('cmpCreateGameForm initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.durationSelectors = document.getElementsByClassName('duration-selector');
        _.durationDescriptionContainer = document.getElementById('duration-description-container')

        _.onChangeEvent()
    },

    onChangeEvent: function ()
    {
        const _ = this;

        for (let selector of _.durationSelectors) {
            selector.addEventListener('change', (e) =>
            {
                _.durationDescriptionContainer.classList.add('active');
                _.durationDescriptionContainer.innerText = (e.target).getAttribute('data-duration-description')
            })
        }

    }
}

export default cmpCreateGameForm;
